import { ModularLearningDetails } from '@/pages/ModularLearningDeprecated/ModularLearningDetails';
import { UseSurveyViewerHook } from '@/features/course/learner/hooks/useSurveyViewer';

export const SurveyView = (props: ReturnType<UseSurveyViewerHook>): JSX.Element => {
  return (
    <ModularLearningDetails
      title={props.survey?.title || ''}
      spaceId={props.survey?.spaceId}
      learningId={Number(props.survey?.id)}
      loading={props.loadingLearning}
      pages={props.pages}
      isDrawerOpen={props.isDrawerOpen}
      pageTotalCount={props.pageTotalCount}
      pageActiveCount={props.pageActiveCount}
      prevPageActiveCount={props.prevPageActiveCount}
      onNewPageClick={props.onSetPageActiveByIndex}
      onUpNavigationClick={props.onSetPrevPageActive}
      onDownNavigationClick={props.onSetNextPageActive}
      onSetDrawerOpen={props.setDrawerOpen}
      onSetPageActive={props.onSetPageActive}
      onPageChange={props.onPageChange}
    />
  );
};
